import {
  Order,
  OrderPageQuery,
  OrderResource,
  OrderResourcePage,
  PageOf
} from '@/models'

import {
  generateRead,
  generateReadPage,
  generateUpdateSubresource
} from './crudGenerator'

/**
 * Converts OrderResource to Order.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOrderResource (resource: OrderResource): Order {
  return {
    id: resource.id,
    invoiceId: resource.invoiceId,
    type: resource.type,
    code: resource.code,
    total: resource.total,
    createdAt: new Date(resource.createdAt),
    authorizedAt: resource.authorizedAt ? new Date(resource.authorizedAt) : null,
    startedAt: resource.startedAt ? new Date(resource.startedAt) : null,
    completedAt: resource.completedAt ? new Date(resource.completedAt) : null,
    canceledAt: resource.canceledAt ? new Date(resource.canceledAt) : null,
    status: resource.status,
    items: resource.items
  }
}

/**
 * Converts OrderResourcePage to PageOf<Order>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOrderResourcePage (page: OrderResourcePage): PageOf<Order> {
  return {
    elements: page.orders.map(parseOrderResource),
    total: page.count
  }
}

const url = '/ordering'
const entity = 'orders'
export default {
  /**
   * Cancels an existing Order.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Order id to be canceled.
   */
  cancelOrder: generateUpdateSubresource(url, entity, 'canceled'),

  /**
   * Completes an existing Order.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Order id to be completed.
   */
  completeOrder: generateUpdateSubresource(url, entity, 'completed'),

  /**
   * Gets an Order.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Order id to be fetched.
   */
  fetchOrder: generateRead(url, entity, parseOrderResource),

  /**
   * Gets a page of Order.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query options.
   */
  fetchOrderPage: generateReadPage<Order, OrderResourcePage, OrderPageQuery>(url, entity, parseOrderResourcePage),

  /**
   * Starts an existing Order.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Order id to be started.
   */
  startOrder: generateUpdateSubresource(url, entity, 'started')
}
